import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { currentUserInfo } from 'atoms';
import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { modifyMyEmail } from 'fetchers';
import ModifyButton from './ModifyButton';

const ModifyChangeEmail = ({ setIsOpen }) => {
  const [email, setEmail] = useState('');
  const {
    user: { no },
  } = useRecoilValue(currentUserInfo);

  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const modifyMutation = useMutation(() => modifyMyEmail(email, no), {
    onSuccess: (data) => {
      if (data.status === 200) {
        queryClient.refetchQueries();
        enqueueSnackbar('이메일 변경에 성공했습니다');
        setIsOpen((prev) => !prev);
      } else if (data?.data?.error) {
        enqueueSnackbar(data.data.error.message);
      }
    },
    onError: () =>
      enqueueSnackbar('이메일 변경에 실패했습니다. 다시 시도해주세요'),
  });

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async () => {
    if (email.length === 0) {
      enqueueSnackbar('이메일을 입력해주세요');
    } else {
      modifyMutation.mutate();
    }
  };

  return (
    <ModifyChangeEmailConatiner className='bg-gray-100'>
      <ModifyChangeEmailInputContainer className='d-flex flex-row align-items-center justify-content-around px-2 px-sm-3'>
        <ModifyChangeEmailInput
          className='form-control pl-2'
          placeholder='변경 이메일을 입력해주세요'
          onChange={handleChange}
        />
      </ModifyChangeEmailInputContainer>
      <ModifyButton handleSubmit={handleSubmit} />
    </ModifyChangeEmailConatiner>
  );
};

const ModifyChangeEmailConatiner = styled.section``;
const ModifyChangeEmailInputContainer = styled.section`
  height: 84px;
`;

const ModifyChangeEmailInput = styled.input``;

export default ModifyChangeEmail;
